export const siteId = 3397194
export const hotjarVersion = 6
